import { cva } from 'class-variance-authority'

export const buttonVariants = cva(
  'group flex flex-shrink relative select-none self-start items-center whitespace-nowrap rounded-lg font-medium [&>svg]:size-4 [&>svg]:text-inherit focus-visible:outline-none transition-[transform,background-color,color,opacity,box-shadow] duration-150 ease-out active:scale-[0.98]',
  {
    variants: {
      variant: {
        primary:
          'focus-visible:shadow-focus-bordered-light dark:focus-visible:shadow-focus-bordered-dark dark:bg-white dark:text-black bg-gray-900 text-white active:brightness-[.85] hover:brightness-95 hover:bg-gray-800 dark:hover:bg-gray-200 disabled:hover:bg-gray-900 dark:disabled:hover:bg-white',
        secondary:
          'bg-white ring-1 focus-visible:ring-2 focus-visible:ring-blue-500 ring-inset ring-gray-200 dark:ring-gray-700 text-primary active:brightness-[.95] hover:bg-gray-100 dark:bg-gray-900 dark:hover:bg-gray-800 disabled:hover:bg-white dark:disabled:hover:bg-gray-900',
        danger:
          'focus-visible:shadow-focus-bordered-light dark:focus-visible:shadow-focus-bordered-dark bg-red-500 text-white active:brightness-[.9] hover:brightness-95 disabled:hover:bg-red-500',
        tertiary:
          'bg-transparent focus-visible:ring-2 focus-visible:ring-blue-500 ring-inset text-gray-900 active:brightness-[.9] hover:bg-gray-200 data-[state=open]:bg-gray-200 dark:text-white dark:hover:bg-gray-800 dark:data-[state=open]:bg-gray-800 disabled:hover:bg-transparent dark:disabled:hover:bg-transparent',
        secondaryAction:
          'focus-visible:ring-2 focus-visible:ring-blue-500 text-blue-500 bg-transparent !text-sm !border-none !p-0 hover:opacity-75 active:opacity-60 [&>svg]:size-3 !gap-1.5',
      },
      size: {
        small: 'text-sm gap-2 px-2.5 py-1.5 [&>svg]:my-0.5',
        base: 'text-base gap-2.5 px-3.5 py-2.5 [&>svg]:my-1',
      },
      isDisabled: {
        true: 'opacity-50 cursor-not-allowed active:scale-100 active:brightness-100 active:opacity-50 hover:brightness-100 hover:opacity-50 hover:bg-inherit dark:hover:bg-inherit hover:border-inherit',
      },
      isLoading: {
        true: 'cursor-default active:scale-100 active:brightness-100 active:opacity-50 hover:brightness-100 hover:opacity-50 hover:bg-inherit hover:border-inherit',
      },
      fullWidth: {
        true: 'w-full',
      },
      alignLeft: {
        true: 'justify-start',
        false: 'justify-center',
      },
    },
    compoundVariants: [
      // secondaryAction stays fully opaque while loading — the icon swap alone signals progress, dimming the subtle blue text would hurt legibility
      {
        variant: 'secondaryAction',
        isLoading: true,
        class: '!opacity-100 hover:!opacity-100 active:!opacity-100',
      },
    ],
    defaultVariants: {
      variant: 'primary',
      size: 'base',
      alignLeft: false,
    },
  },
)

export const buttonShortcutVariants = cva(
  'font-normal -mr-1 py-0.5 flex whitespace-nowrap items-center justify-center rounded-[4px] transition-colors duration-100 ease-out',
  {
    variants: {
      variant: {
        primary:
          'bg-gray-600 text-white group-hover:bg-gray-600 dark:bg-gray-200 dark:text-black dark:group-hover:bg-gray-300',
        secondary:
          'bg-gray-200 text-primary group-hover:bg-gray-300 dark:bg-gray-800 dark:group-hover:bg-gray-700',
        tertiary:
          'bg-gray-200 text-gray-900 group-hover:bg-gray-300 dark:bg-gray-700 dark:text-white dark:group-hover:bg-gray-600',
        danger: 'bg-red-400 text-white',
        secondaryAction: 'bg-blue-500 text-white',
      },
      fullWidth: {
        true: 'absolute right-2.5 mr-0',
      },
      size: {
        small: 'px-1 text-xs',
        base: 'px-1.5 text-sm',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'base',
    },
  },
)
